import { render } from "./DeleteProjectFiles.vue?vue&type=template&id=6d03c58d"
import script from "./DeleteProjectFiles.vue?vue&type=script&lang=js"
export * from "./DeleteProjectFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__